import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { Container, Row, } from 'react-bootstrap';
import { withRouter } from '../withRouter';
import QRCode from 'qrcode.react';
import styles from "components/Room/PlayerList.module.scss";
import { FaCopy, } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import * as Sentry from '@sentry/react';
import { getStateCallbacks } from "colyseus.js";
import { getBaseUrl } from "helpers/url";

import GameCityPic from "images/WelcomeGameCityText.png"
import Logo from "images/logo-high-res.png"
import Player from './Player';


class PlayerList extends Component {
    static displayName = PlayerList.name;

    constructor(props) {
        super(props);

        this.state = {
            players: [],
            collapse: true,
            scrolledPastHeader: false,
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll, { passive: true })
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    componentDidUpdate(prevProps, prevState) {
        if ((this.props.room.roomOpen && !prevProps.room.roomOpen)) {
            if (this.props.room.isHost) {
                //this.setPlayerListeners();
                this.startLocationChecks();
            }
        }

        if (this.props.room.roomOpen == false && prevProps.room.roomOpen == true) {
            //if (this.props.room.isHost) {
            this.setState({ players: [], })
            //}
        }
    }

    handleScroll = (event) => {
        const sidebarElement = document.querySelector(`.${styles.sideBar}`);
        if (!sidebarElement) return;

        // Get the sidebar's original position in the document
        // We need to temporarily remove fixed positioning to get the true position
        const isCurrentlyFixed = this.state.scrolledPastHeader;

        if (isCurrentlyFixed) {
            // If it's fixed, we use the stored initial position
            if (this.initialSidebarTop === undefined) {
                // Fallback: assume it should be at the current scroll position
                this.initialSidebarTop = window.scrollY;
            }
        } else {
            // When it's not fixed, we can accurately measure its position
            this.initialSidebarTop = sidebarElement.getBoundingClientRect().top + window.scrollY;
        }

        // Check if we've scrolled past the initial position
        if (window.scrollY >= this.initialSidebarTop) {
            if (!this.state.scrolledPastHeader) {
                this.setState({ scrolledPastHeader: true });
            }
        } else {
            if (this.state.scrolledPastHeader) {
                this.setState({ scrolledPastHeader: false });
            }
        }
    }

    handlePosition = () => {
        if (!this.state.scrolledPastHeader) {
            return { position: 'absolute'};
        }

        // Stick it to the top of the viewport
        return { position: 'fixed'};
    }

    async checkAndAddPlayer(player) {
        if (!this.state.players.find(elem => elem.id == player.id)) {
            this.setState((prevState) => {
                return { players: [...prevState.players, player] }
            }, () => {
                player.onChange = (changes) => {
                    let statePlayers = [...this.state.players];
                    let pos = statePlayers.map(function (e) { return e.id; }).indexOf(player.id);
                    let statePlayer = { ...statePlayers[pos] };
                    changes.forEach(change => {
                        //console.log(change.field);
                        //console.log(change.value);
                        //console.log(change.previousValue);
                        statePlayer[change.field] = change.value;
                    });
                    statePlayers[pos] = statePlayer;
                    this.setState({ players: statePlayers });
                };
            });
        }
    }

    removePlayer(id) {
        this.setState((prevState) => {
            return { players: prevState.players.filter(x => x.id !== id), }
        });
    }

    async setPlayerListeners() {
        console.log("setting player listeners");
        const $ = getStateCallbacks(this.props.room.room);

        $(this.props.room.room.state).players.onAdd = (player, key) => {
            console.log(player, "has been added at", key);
            this.checkAndAddPlayer(player);

        };
        $(this.props.room.room.state).players.onRemove = (player, key) => {
            console.log(player, "has been removed at", key);
            player.onChange = (changes) => { };
            this.removePlayer(player.id);
        };
    }

    toggleCollapse = () => {
        this.setState({ collapse: !this.state.collapse });
    }

    copyTextToClipboard = () => {
        console.log("copy to clipboard");

        const baseUrl = getBaseUrl();
        const text = `${baseUrl}/join?qrCode=${this.props.room.roomId}`;
        console.log(text);

        if ('clipboard' in navigator) {
            navigator.clipboard.writeText(text);
        } else {
            document.execCommand('copy', true, text);
        }
    }


    closeRoom = () => {
        this.props.room.room.leave(true);
        this.props.navigate("/");
    }

    logout = () => {
        //TODO: allow roku users to log out.
    }

    startLocationChecks() {
        if (this.props.room.roomOpen) {
            this.props.room.room.send("location_check", { gameId: "lobby", });

        }
        this.locationCheckInterval = setInterval(() => {
            if (this.props.room.roomOpen) {
                this.props.room.room.send("location_check", { gameId: "lobby", });
            }
        }, 10000);
    }

    render() {
        const baseUrl = getBaseUrl();

        const shouldCollapse = this.state.collapse && !window.location.href.includes("/lobby") && !this.props.isTvApp;
        const positionStyles = this.handlePosition();
        return (
            <div key="side-bar" className={`${styles.sideBar} ${shouldCollapse && styles.collapse}`} style={{
                display: this.props.room.roomOpen && this.props.room.isHost ? "block" : "none", opacity: this.props.room.roomOpen && this.props.room.isHost ? "1" : "0", height: "100%", width: "47.5vh", position: positionStyles.position}}>
                <Container className={styles.sideBarInner}>
                    {
                        this.props.isTvApp ?
                            <img className={styles.welcomePic} src={Logo} alt="welcome" />
                            :
                            <h2>LET'S PLAY</h2>
                    }
                    <div className={styles.lobbyInfo}>
                        {
                            this.props.isTvApp &&
                            <div>
                                <p>Scan the QR Code to join the fun!<br/>Room code: <strong>{this.props.room.roomId}</strong></p>
                            </div>
                        }
                        {
                            !this.props.isTvApp &&
                            <div>
                                    <p>To join the game, simply scan the QR code below or head to <strong>Game.City</strong> use the room code: <strong>{this.props.room.roomId}</strong>                                    <button className={`${styles.button} ${styles.small} ${styles.alternate}`} style={{ marginLeft: "10px" }} onClick={this.copyTextToClipboard}><FaCopy /></button>
                                </p>
                                <div className={`text-center`}>
                                    <button onClick={() => this.props.navigate("/help")} className={`${styles.button}`}>How To Setup</button>
                                </div>
                            </div>
                        }
                    </div>
                    {this.props.isTvApp ? (
                        <div className={`${styles.qrCodeBox}`}>
                            <QRCode
                                style={{ width: "15vh", height: "15vh" }}
                                value={`${baseUrl}/join?roku=true&loginAppType=${this.props.devices.appType}&qrCode=${this.props.room.roomId}`}
                            />
                        </div>
                    ) : (
                        <div className={`${styles.qrCodeBox}`}>
                            <QRCode
                                style={{ width: "15vh", height: "15vh" }}
                                value={`${baseUrl}/join?qrCode=${this.props.room.roomId}`}
                            />
                        </div>
                    )}
                    <div className={styles.playersJoined}>
                        <h2>Who's in?</h2>
                        <div className={styles.playersJoinedInner}>
                            <Row className="w-100">
                                {
                                    this.props.room.players.length > 0 ?
                                    this.props.room.players.map((p, index) => {
                                        return <Player player={p} key={index}/>
                                    })
                                    :
                                    <p><br/>Waiting for players to join...<br/></p>
                                }
                            </Row>
                        </div>
                    </div>
                    <div className={`${styles.buttonGroup}`}>
                        {
                            !this.props.isTvApp &&
                            <div className={`text-center`}>
                                <button onClick={this.props.isTvApp ? this.logout : this.closeRoom} className={`${styles.button} ${styles.alternate} ${styles.small}`}>{this.props.isTvApp ? "Log Out" : "Close Room"}</button>
                            </div>
                        }
                        {
                            !window.location.pathname.includes("lobby") && !this.props.isTvApp &&
                            <div className={`text-center`}>
                                <button onClick={() => this.props.navigate("/lobby")} className={`${styles.button} ${styles.small}`}>Return to lobby</button>
                            </div>
                        }
                    </div>
                </Container>
                {
                    !window.location.pathname.includes("lobby") && !this.props.isTvApp &&
                    <div className={`${styles.collapseButton} ${shouldCollapse && styles.popout}`} onClick={this.toggleCollapse}>
                        <span className={styles.popoutText}><h4>Lobby</h4></span> <IoIosArrowDown className={`${styles.arrow} ${shouldCollapse && styles.popout}`} />
                    </div>
                }
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
        devices: state.devices
    };
}

export default connect(mapStateToProps, null)(withRouter(PlayerList));
